import { useRef } from "react";
import './App.scss';
import { MdOutlineEmail } from 'react-icons/md';
import { GrLinkedinOption } from 'react-icons/gr';
import { FaWhatsapp } from 'react-icons/fa';
import emailjs from "emailjs-com";

function Contact() {
  const form = useRef<HTMLFormElement | null>(null);

  const sendEmail = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (form.current) {
      emailjs
        .sendForm(
          "service_3wr57c3",
          "template_me9clif",
          form.current,
          "-c_VIPBK7PsOLk2pT"
        )
        .then(
          (result) => {
            window.alert("Sua mensagem foi enviada com sucesso!");
            console.log(result.text);
          },
          (error) => {
            window.alert("Não foi possível enviar sua mensagem. Por favor, entre em contato conosco pelo WhatsApp.");
            console.log(error.text);
          }
        );

      // Limpa o formulário após o envio
      form.current.reset();
    }
  };

  return (
    <>
      <div className='title-box'>
        <p className='subtitle'>Get in Touch</p>
        <p className='title'>Entrar em contato</p>
      </div>
      <div className='container'>
        <div className='section-0'>
          <div className='card'>
            <MdOutlineEmail className="icon" />
            <p className='social-type'>Email</p>
            <p className='social-adress'>cazarin.junior@gmail.com</p>
            <a
              href="mailto:cazarin.junior@gmail.com"
              target="_blank"
              rel="noreferrer"
            >
              Send a message
            </a>
          </div>
          <div className='card'>
            <GrLinkedinOption className="icon" />
            <p className='social-type'>Linkedin</p>
            <p className='social-adress'>Luiz Claudio</p>
            <a
              href="https://www.linkedin.com/in/luiz-claudio-cazarin/"
              target="_blank"
              rel="noreferrer"
            >
              Send a message
            </a>
          </div>
          <div className='card'>
            <FaWhatsapp className="icon" />
            <p className='social-type'>WhatsApp</p>
            <p className='social-adress'>+55 (61)98301-7727</p>
            <a
              href="https://api.whatsapp.com/send?phone=5561983017727"
              target="_blank"
              rel="noreferrer"
            >
              Send a message
            </a>
          </div>
        </div>

        <form ref={form} onSubmit={sendEmail} className='section-1'>
          <input type="text" name="name" required placeholder='Seu nome completo' />
          <input type="email" name="email" required placeholder='Email' />
          <textarea name="message" id="message" rows={7} required placeholder='Sua mensagem'></textarea>
          <button type='submit'>Send Message</button>
        </form>

      </div>
    </>
  );
}

export default Contact;
